// BaseUrl reads from .env.development or .env.production automatically
// npm start -> uses .env.development (localhost)
// npm run build -> uses .env.production (AWS)
export const BaseUrl=process.env.REACT_APP_API_URL?.trim().replace(/\/$/, "");